import React from "react";

import { TerminalFileBuildOptionTypes } from "types";

import TextBlock from "../components/textBlock";

type FileBuildData = {
	fileBuildOption: string;
	fileType: string;
};

type FileBuildViewProps = { fileBuild: FileBuildData };

const FileBuildView = ({ fileBuild }: FileBuildViewProps) => {
	const { fileBuildOption, fileType } = fileBuild || {};

	return (
		<>
			<TextBlock
				value={
					TerminalFileBuildOptionTypes.getByValue(fileBuildOption)
						?.displayName
				}
				dataAutotest="terminalFileBuildOptionType"
			/>
			{TerminalFileBuildOptionTypes?.getByValue?.(fileBuildOption)
				?.value === TerminalFileBuildOptionTypes.Other.value && (
				<TextBlock
					label="File Type"
					value={fileType}
					dataAutotest="fileTypeOther"
				/>
			)}
		</>
	);
};

export default FileBuildView;
